'use client';

import { SwiperSlider, TestimonialCard } from '../../../components';
import { useTranslations } from 'next-intl';
import { useBreakpoint } from '../../../hooks';
import { getBreakpointValue } from '../../../types';
import { Testimonial } from '../../../types/Testimonial/domain/testimonial';
import { LandingPageHeadline } from './components/LandingPageHeadline';
import { LandingPageSection } from './styles';

type Props = {
    testimonials: Testimonial[];
};

const LandingPageTestimonialsSection = ({ testimonials }: Props) => {
    const t = useTranslations('landing_page');
    const breakpoint = useBreakpoint();

    const cardWidth = getBreakpointValue(breakpoint, 360, 400, 504);

    const testimonialCards = testimonials.map((testimonial, index) => (
        <TestimonialCard
            key={testimonial.id}
            testimonial={testimonial}
            index={index}
            width={cardWidth}
        />
    ));

    return (
        <LandingPageSection breakpoint={breakpoint}>
            <LandingPageHeadline
                headline={t('testimonials_title')}
                description={t('testimonials_description')}
            />
            <SwiperSlider
                elements={testimonialCards}
                slidesPerView={2}
                spaceBetween={24}
                breakpoints={{
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 24
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24
                    }
                }}
            />
        </LandingPageSection>
    );
};

export { LandingPageTestimonialsSection };
